// extracted by mini-css-extract-plugin
export default {"content":"styles_content__h1UhB","title":"styles_title__I3VlK","description":"styles_description__ijgmU","form_item":"styles_form_item__O-m4V"};